module.exports = __webpack_public_path__ + "static/qr-b29dedede9b1e332b66d39148574a15b.jpg";